// <picture> z WebP + fallback PNG. display:contents nie zmienia layoutu wrappera.
export const SmartImg = ({ src, alt = "", className = "", ...rest }) => {
  const webp = src.replace(/\.png$/i, ".webp");
  return (
    <picture className="contents">
      <source srcSet={webp} type="image/webp" />
      <img src={src} alt={alt} className={className} {...rest} />
    </picture>
  );
};
